import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {OrderFormService} from '../../services/order-form.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {Column} from '../../share/models/column';
import {OrderForm} from '../../models/order-form';
import {ExchangeProduct} from '../../models/exchange-product';
import * as _ from 'lodash';
import {OverlayPanel} from 'primeng/overlaypanel';
import {saveAs} from 'file-saver/dist/FileSaver';
import {UserLogged} from '../../models/userLogged';
import {SelectItem} from '../../models/select-item';
import {environment} from '../../../environments/environment';
import {TimeSyncJiraIssue} from '../../models/TimeSyncJiraIssue';
import {JiraService} from '../../services/jira.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {TechnicalPopService} from '../../services/technical-pop.service';

@Component({
  selector: 'app-time-sync-profile',
  templateUrl: './time-sync-profile.component.html',
  styleUrls: ['./time-sync-profile.component.scss']
})
export class TimeSyncProfileComponent implements OnInit {

  loading = false;
  error: boolean;
  errorPopup: boolean;
  errorExport: boolean;
  orderForms: OrderForm[] = [];
  selectedOrderForms: OrderForm[];
  exProducts: ExchangeProduct[] = [];
  orderFormsCols: Column[];
  selectedCPopCols: Column[];
  historiesCols: Column[];
  companyName: string;
  companyUniqid: string;
  totalNbOfColumns: number;
  tabData: any;
  loggedInUser: UserLogged;
  rowGroupMetadata: any;
  selectedCol: any = null;
  selectedRowIndex: any = null;

  /* jira feature variables */
  displayJiraFeature: boolean;
  public isJiraPopUp = false;
  isSendToJiraDisabled = false;
  jiraCustomDescription = '';
  selectedPriority = 'support';
  successCreateJira = false;
  jiraIssueCode: string;
  selectedXcoForJira: any;
  jiraCreationError = false;
  public crossConnectItemForJira: SelectItem[] = [];
  private jiraIssue: TimeSyncJiraIssue = new TimeSyncJiraIssue();
  jiraLink: string;


  constructor(
    private route: ActivatedRoute,
    private orderFormService: OrderFormService,
    private authenticationService: AuthenticationService,
    private jiraService: JiraService,
    protected utilsService: UtilsService,
    protected technicalPopService: TechnicalPopService,
  ) {
  }

  ngOnInit() {
    this.loggedInUser = this.authenticationService.userCurrent;
    this.loading = true;
    this.error = false;
    this.errorPopup = false;
    this.errorExport = false;
    this.displayJiraFeature = environment.displayJiraFeature;
    this.selectedCPopCols = [];
    this.initializeCols();
    this.route.paramMap.subscribe(params => {
      this.companyUniqid = params.get('companyUniqId');
      this.orderFormService.getTimeSyncDataProfile(this.companyUniqid).subscribe({
        next: (orderForms) => {
          this.companyName = orderForms['companyName'];
          this.orderForms = orderForms['orderForms'].sort((x, y) => +new Date(y.executionDate) - +new Date(x.executionDate));
          this.selectedOrderForms = this.orderForms.filter(order => order.active === true);
          const products = [];
          Object.keys(orderForms['products']).map(function (key) {
            products.push(orderForms['products'][key]);
            return products;
          });
          this.exProducts = products;
          this.initializeHeaders(orderForms['pops']);
          if (this.selectedOrderForms.length === 0) {
            this.selectedOrderForms.push(...this.orderForms);
            _.forEach(this.selectedCPopCols, (pop) => {
              _.forEach(this.exProducts, (product) => {
                if (product[pop.field]) {
                  _.forEach(product[pop.field], (item) => {
                    item.isDisplayed = true;
                  });
                }
              });
            });
          }
          this.updateRowGroupMetaData();
          for (const key in this.exProducts) {
            if (Object.keys(this.exProducts[key]).length > 2) {
              const exProduct = this.exProducts[key];
              for (const i in exProduct) {
                if (Array.isArray(exProduct[i])) {
                  exProduct[i].forEach(obj => {
                    if (obj.isDisplayed === true) {
                      // collect  the Xco list for the jira pop up
                      this.crossConnectItemForJira.push({label: obj.crossConnectId, value: obj});
                    }
                  });
                }
              }
            }
          }
        },
        error: () => {
          this.error = true;
        }
      });
    });
  }

  private initializeCols() {
    this.orderFormsCols = [
      {field: 'status', header: 'Status', width: '8%'},
      {field: 'identificationNumber', header: 'Order Form Number', width: '12%'},
      {field: 'mrc', header: 'MRC', width: '9%'},
      {field: 'term', header: 'Term', width: '9%'},
      {field: 'invoiceFrequency', header: 'Invoice frequency', width: '11%'},
      {field: 'renewableStatus', header: 'Contract Renewable Status', width: '15%'},
      {field: 'renewalDate', header: 'Renewal Date', width: '11%'},
      {field: 'executionDate', header: 'Contract Execution Date', width: '11%'},
      {field: 'terminationDate', header: 'Contract Expiry Date', width: '11%'},
    ];
  }

  private initializeHeaders(pops) {
    this.totalNbOfColumns = 0;
    for (const pop of pops) {
      if (!this.selectedCPopCols.some(elem => elem.field === pop.cPop.uuid)) {
        this.totalNbOfColumns = this.totalNbOfColumns + 1;
        this.selectedCPopCols.push({
          field: pop.cPop.uuid,
          header: pop.cPop.displayId,
          width: '1%',
          colspan: 1,
          value: pop.cPop.displayId,
        });
      }
    }
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.exProducts) {
      for (let i = 0; i < this.exProducts.length; i++) {
        const rowData = this.exProducts[i];
        const exchangeName = rowData.exchangeName;
        if (i === 0) {
          this.rowGroupMetadata[exchangeName] = {index: 0, size: 1};
        } else {
          const previousRowData = this.exProducts[i - 1];
          const previousRowGroup = previousRowData.exchangeName;
          if (exchangeName === previousRowGroup) {
            this.rowGroupMetadata[exchangeName].size++;
          } else {
            this.rowGroupMetadata[exchangeName] = {index: i, size: 1};
          }
        }
      }
    }
    this.loading = false;
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  onRowSelect(event) {
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          _.forEach(prod[pop.field], (item) => {
            if (item['orderFormId'] === event.data.identificationNumber) {
              item.isDisplayed = true;
            }
          });
        }
      });
    });
  }

  onRowUnselect(event) {
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          _.forEach(prod[pop.field], (item) => {
            if (item['orderFormId'] === event.data.identificationNumber) {
              item.isDisplayed = false;
            }
          });
        }
      });
    });
  }

  onHeaderCheckbox(event) {
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          _.forEach(prod[pop.field], (item) => {
            item.isDisplayed = !!event.checked;
          });
        }
      });
    });
  }

  getCellClasses(exProduct: any, index: string): string {
    let cssClass = '';
    if (!exProduct[index]) {
      return cssClass;
    }
    if (exProduct[index].length > 0) {
      if (exProduct[index].find((prod) => prod['status'] === 'Configured' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Configured');
        cssClass = 'configured-status ' + itemTypeDisplayed + ' icon-common';
      } else if (exProduct[index].find(prod => prod['status'] === 'Trial started' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Trial started');
        cssClass = 'trial-started-status ' + itemTypeDisplayed + ' icon-common';
      } else if (exProduct[index].find(prod => prod['status'] === 'Trial ended' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Trial ended');
        cssClass = 'trial-ended-status ' + itemTypeDisplayed + ' icon-common';
      } else if (exProduct[index].find(prod => prod['status'] === 'New' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'New');
        cssClass = 'new-status ' + itemTypeDisplayed + ' icon-common';
      } else if (exProduct[index].find(prod => prod['status'] === 'Deconfigured' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Deconfigured');
        cssClass = 'deconfigured-status ' + itemTypeDisplayed + ' icon-common';
      }
      return cssClass;
    }
  }

  private getItemTypeDisplayed(product: any, status: string) {
    const itemTypes = this.getTypesList(product, status);
    let itemTypeDisplayed = itemTypes[0];
    if (itemTypes.length > 1) {
      itemTypeDisplayed = 'icon-multiple';
    }
    return itemTypeDisplayed;
  }

  private getTypesList(products: any, status: string): any[] {
    const productsFiltered = products.filter((prod) => prod['status'] === status && prod['isDisplayed']);
    const types = [];
    _.forEach(productsFiltered, (prod) => {
      const type = this.getItemType(prod);
      if (types.find(typ => {
        return typ.label === type.label;
      }) === undefined) {
        types.push(type.class);
      }
    });
    return types;
  }

  private getItemType(prod) {
    if (prod['isProtected'] === true && prod['isEncrypted'] === true) {
      return {
        label: 'Encrypted and Protected',
        value: 'assets/images/icons/protected_encrypted_icon.png',
        class: 'icon-encrypted-protected'
      };
    } else if (prod['isProtected'] === true && prod['isEncrypted'] === false) {
      return {label: 'Protected', value: 'assets/images/icons/protected_icon.png', class: 'icon-protected'};
    } else if (prod['isProtected'] === false && prod['isEncrypted'] === true) {
      return {label: 'Encrypted', value: 'assets/images/icons/encrypted_icon.png', class: 'icon-encrypted'};
    } else if (prod['isArbitration']) {
      return {label: 'Arbitration', value: 'assets/images/icons/arbitrated_icon.png', class: 'icon-arbitrated'};
    } else {
      return {label: 'RF', value: 'assets/images/icons/rf_icon.png', class: 'icon-rf'};
    }
  }

  displayItem(event, exProduct: ExchangeProduct, col: any, overlayPanel: OverlayPanel) {
    this.initializePopupCols();
    if (!col || !exProduct[col.field]) {
      return;
    }
    this.tabData = [];
    _.forEach(exProduct[col.field], (res) => {
      this.tabData.push({
        'header': res.productName + ' @' + res.commercialPop,
        'status': res.status,
        'type': res.type,
        'typeImg': this.getTypeImg(res.type),
        'carrier': res.carrier,
        'hosting': res.hosting,
        'crossConnectId': res.crossConnectId,
        'technicalPop': res.technicalPop,
        'histories': res.histories,
      });
    });
    overlayPanel.toggle(event);
  }

  private initializePopupCols() {
    this.historiesCols = [
      {field: 'type', header: '', width: '30%'},
      {field: 'startDate', header: 'Start date', width: '30%'},
      {field: 'endDate', header: 'End date', width: '20%'},
    ];
  }

  private getTypeImg(type: string) {
    if (type === 'Encrypted and Protected') {
      return 'assets/images/icons/protected_encrypted_icon.png';
    } else if (type === 'Protected') {
      return 'assets/images/icons/protected_icon.png';
    } else if (type === 'Encrypted') {
      return 'assets/images/icons/encrypted_icon.png';
    } else if (type === 'Arbitration') {
      return 'assets/images/icons/arbitrated_icon.png';
    } else {
      return 'assets/images/icons/rf_icon.png';
    }
  }

  onCellHover(col: any, rowIndex: any): void {
    this.selectedCol = col;
    this.selectedRowIndex = rowIndex;
  }

  onCellLeave(): void {
    this.selectedCol = null;
    this.selectedRowIndex = null;
  }

  isColumnHighlighted(col: any): boolean {
    return this.selectedCol === col;
  }

  isRowHighlighted(rowIndex: number): boolean {
    return this.selectedRowIndex === rowIndex;
  }

  getIsDisplayed(exProduct: any, index: string): boolean {
    if (!exProduct[index]) {
      return false;
    }
    if (exProduct[index].length > 0) {
      return exProduct[index].some(elem => elem['isDisplayed'] === true);
    }
  }

  exportAsExcel() {
    this.errorExport = false;
    this.orderFormService.exportAsExcel(this.companyUniqid, 'time_sync_as_a_service', this.displayedItemUuids()).subscribe({
        next: res => {
          const fileMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = this.b64toBlob(res['file_content'], fileMimeType, null);
          saveAs(blob, res['file_name']);
          this.updateRowGroupMetaData();
        }, error: () => {
          this.errorExport = true;
        }
      }
    );
  }

  private displayedItemUuids(): string[] {
    return this.exProducts.flatMap(exProduct => Object.values(exProduct)
      .filter(Array.isArray)
      .flat()
      .filter(item => item.isDisplayed === true)
      .map(item => item.uuid));
  }

  private b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || 'application/pdf';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  openSendJiraPopup() {
    this.isJiraPopUp = true;
  }

  setIsSendToJiraFlag() {
    this.isSendToJiraDisabled = false;
  }

  createIssue() {
    if (!this.selectedXcoForJira || this.selectedXcoForJira.length === 0 || this.jiraCustomDescription.length === 0) {
      this.isSendToJiraDisabled = true;
      return;
    }
    this.isSendToJiraDisabled = false;

    // Set common JIRA issue properties
    this.jiraIssue.reporter = this.loggedInUser;
    this.jiraIssue.createdBy = this.loggedInUser.username;
    const xcoList = this.selectedXcoForJira.map(xco => xco.crossConnectId).join(', ');
    this.jiraIssue.subject = `Issue Impacting Precision Time Exchange service on [${xcoList}]`;
    this.jiraIssue.isSupport = this.selectedPriority === 'support';

    // prepare Description
    // Remove any HTML tags and extra spaces , replace p  tags by /n and prevent adding nbsp in the jira description
    const defaultDescription = `There seems to be an outage in the Precision Time Exchange service, impacting the following crossConnect.\n Please investigate.`;
    const xcoDescription = this.selectedXcoForJira.map(xco => `- ${xco.crossConnectId}`).join(', ');
    let finalDescription = `${defaultDescription}${xcoDescription} \n *Customer addl comment:* \n${this.jiraCustomDescription}`;
    finalDescription = finalDescription.replace(/<\/p>/g, '\n').replace(/<br\s*\/?>/g, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

    const jiraIssueData = {
      description: finalDescription,
      subject: this.jiraIssue.subject,
      createdByUserName: this.jiraIssue.reporter.username,
      createdByEmail: this.jiraIssue.reporter.email,
      isSupport: this.selectedPriority === 'support',
      isQuincyProject: true,
      isMckayProject: false,
    };
    this.utilsService.lockUi();
    // Create Jira issue
    this.jiraService.createJiraIssue(jiraIssueData).subscribe({
      next: (response) => {
        this.successCreateJira = true;
        this.jiraIssueCode = response['created_issue_key'];
        this.jiraLink = response['jira_link'];
        this.isJiraPopUp = false;
        this.cancel();
        this.utilsService.unlockUi();
      },
      error: () => {
        this.jiraCreationError = true;
        this.isJiraPopUp = false;
        this.cancel();
        this.utilsService.unlockUi();
      }
    });
  }

  cancel() {
    this.isJiraPopUp = false;
    this.jiraCustomDescription = '';
  }

}
